import styled, { css } from "../../styled";
import BaseNotification from "./notification";
const statusSelector = ({ status, theme, }) => {
    const { colors } = theme._ui;
    const notificationStatus = {
        neutral: css `
      background: ${colors.inverse.bg.default};
      color: ${colors.inverse.text.default};
    `,
        positive: css `
      background: ${colors.positive.bg.default};
      color: ${colors.positive.text.onDefault};
    `,
        negative: css `
      background: ${colors.negative.bg.default};
      color: ${colors.positive.text.onDefault};
    `,
    };
    return notificationStatus[status];
};
export const Notification = styled(BaseNotification) `
  width: 100%;
  font-size: ${(props) => props.theme._ui.font.size.label.medium};
  line-height: ${(p) => p.theme._ui.font.lineHeight.label.medium};
  font-weight: ${(props) => props.theme._ui.font.weight.label};
  border-radius: ${(p) => p.theme._ui.radii.small};
  ${statusSelector};
`;
export default Notification;
